import React, { FC } from "react";
import cn from "classnames";
import { CHIP_ITEM_VARIANTS,type SelectChipsProps } from "./constants";

const SelectChips: FC<SelectChipsProps> = ({
  rounded = "md",
  children,
  className,
  classNames,
  ...props
}) => {
  const items = React.Children.toArray(children);

  return (
    <div className={cn("flex", className)} {...props}>
      {items.map((child, index) => {
        const isFirst = index === 0;
        const isLast = index === items.length - 1;

        return (
          <div
            key={index}
            className={cn(
              CHIP_ITEM_VARIANTS({
                roundedLeft: isFirst ? rounded : undefined,
                roundedRight: isLast ? rounded : undefined,
              }),
              {
                "-ms-px": !isFirst, 
              },
              classNames?.item
            )}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};

export default SelectChips;